"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var withTreks = 'trips/treks';
var withLodge = 'lodgings/lodges';
var withTheme = 'themes';
var withPlace = 'places';
var withUser = 'users';
var withPayment = 'payments';
var endpoints = {
  auth: {
    login: "".concat(withUser, "/login"),
    signup: "".concat(withUser, "/register"),
    changePassword: "".concat(withUser, "/changepassword")
  },
  treks: {
    my: "".concat(withTreks, "/my"),
    all: {
      withRegion: function withRegion(region) {
        return "".concat(withTreks, "?region=").concat(region, "&per_page=20&page=1");
      },
      withOutRegion: "".concat(withTreks)
    },
    featuredTreks: "".concat(withTreks, "?is_featured=1&region=everest"),
    bookLodge: function bookLodge(trekId, dayNum, lodgeId) {
      return "".concat(withTreks, "/").concat(trekId, "/days/").concat(dayNum, "/attach/").concat(lodgeId);
    },
    addToTrekDay: function addToTrekDay(trekId, dayNum) {
      return "".concat(withTreks, "/").concat(trekId, "/days/").concat(dayNum);
    },
    reviews: function reviews(trekId) {
      return "reviews/trips/".concat(trekId, "/comments");
    },
    reply: function reply(trekId, commentId) {
      return "reviews/trips/".concat(trekId, "/comments/").concat(commentId);
    },
    ratings: function ratings(trekId) {
      return "reviews/trips/".concat(trekId, "/ratings");
    },
    editTrekData: function editTrekData(trekId) {
      return "".concat(withTreks, "/").concat(trekId);
    },
    forkTrek: function forkTrek(trekId) {
      return "".concat(withTreks, "/").concat(trekId, "/fork");
    },
    preferences: function preferences(trekId) {
      return "".concat(withTreks, "/").concat(trekId, "/preferences");
    },
    elevationProfile: function elevationProfile(trekId) {
      return "".concat(withTreks, "/").concat(trekId, "/elevation_profile");
    },
    booking: function booking(trekId) {
      return "".concat(withTreks, "/").concat(trekId, "/bookings");
    },
    getInvoices: function getInvoices() {
      return 'trek-invoices';
    },
    getForkedTreks: function getForkedTreks(id) {
      return "".concat(withTreks, "?parent=").concat(id, "&newmeth=1&price__gt=0");
    },
    freeze: function freeze(trekId) {
      return "".concat(withTreks, "/").concat(trekId, "/freeze");
    },
    overviewData: function overviewData(id) {
      return "".concat(withTreks, "/").concat(id);
    }
  },
  place: {
    listings: {
      withRegion: function withRegion(region) {
        return "".concat(withPlace, "/localities?region=").concat(region);
      },
      withoutRegion: function withoutRegion() {
        return "".concat(withPlace, "/localities");
      } // add per_page and page_here and load more in listing

    },
    details: ''
  },
  themes: {
    mountainFinder: function mountainFinder(id) {
      return "".concat(withTheme, "/mountains?place=").concat(id);
    }
  },
  lodge: {
    listings: '',
    details: function details(id) {
      return "".concat(withLodge, "/").concat(id);
    },
    bookLodge: function bookLodge(id) {
      return "".concat(withLodge, "/").concat(id, "/bookings");
    },
    reviews: function reviews(lodgeId) {
      return "reviews/lodgings/".concat(lodgeId, "/comments");
    },
    reply: function reply(lodgeId, commentId) {
      return "reviews/lodgings/".concat(lodgeId, "/comments/").concat(commentId);
    },
    ratings: function ratings(lodgeId) {
      return "reviews/lodgings/".concat(lodgeId, "/ratings");
    },
    editData: function editData(lodgeId) {
      return "".concat(withLodge, "/").concat(lodgeId);
    }
  },
  profile: {
    getMyData: "".concat(withUser, "/me"),
    getMyInvoices: "".concat(withUser, "/invoices/my"),
    getBookings: "".concat(withUser, "/bookings"),
    getUserData: function getUserData(userId) {
      return "".concat(withUser, "/").concat(userId);
    },
    getCartItems: function getCartItems() {
      return "".concat(withUser, "/bookings/cart");
    },
    getPurchaseCompletedItems: function getPurchaseCompletedItems() {
      return "".concat(withUser, "/bookings/purchase-list");
    },
    getPendingItems: function getPendingItems() {
      return "".concat(withUser, "/bookings/pending");
    },
    patchUserData: function patchUserData(id) {
      return "".concat(withUser, "/").concat(id);
    },
    reviews: function reviews(userId) {
      return "reviews/".concat(withUser, "/").concat(userId, "/comments");
    },
    reply: function reply(userId, commentId) {
      return "reviews/".concat(withUser, "/").concat(userId, "/comments/").concat(commentId);
    },
    ratings: function ratings(userId) {
      return "reviews/".concat(withUser, "/").concat(userId, "/ratings");
    },
    getGuideListings: "".concat(withUser, "/leaders"),
    newslettersSubscriptions: "".concat(withUser, "/newsletters/subscribe"),
    getGuideData: function getGuideData(userId) {
      return "user/".concat(userId, "/guide");
    }
  },
  admin: {
    getUsers: function getUsers() {
      return 'users';
    },
    modifyRole: function modifyRole(id) {
      return "users/".concat(id, "/role");
    },
    verifyGuide: function verifyGuide(id) {
      return "users/".concat(id, "/verify");
    }
  },
  getBookingDetails: function getBookingDetails(bookingType, id) {
    return "".concat(bookingType, "/bookings/").concat(id);
  },
  payment: {
    processId: "".concat(withPayment, "/process"),
    hbl: "".concat(withPayment, "/complete/hblpay"),
    getInvoice: function getInvoice(invoiceId) {
      return "".concat(withPayment, "/invoices/").concat(invoiceId);
    },
    postInvoice: "".concat(withPayment, "/invoices"),
    process: function process(invoiceId) {
      return "".concat(withPayment, "/process/").concat(invoiceId);
    },
    myInvoices: "".concat(withPayment, "/invoices/my"),
    createInvoice: "".concat(withPayment, "/invoices")
  },
  flights: {
    search: 'flights/search',
    getInvoices: 'payments/invoices',
    getInvoiceStatus: function getInvoiceStatus(invoiceNum) {
      return "payments/invoices/".concat(invoiceNum);
    }
  },
  notifications: {
    subscribe: 'users/notifications/subscribe'
  },
  invoice: {
    create: 'payments/invoices'
  }
};

var _default = Object.freeze(endpoints);

exports["default"] = _default;